var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2226_11973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41501 10.9056L6.32891 10.8233L6.24252 10.9053L4.88169 12.1978L4.7866 12.2881L4.88137 12.3788L10.2385 17.5029L10.3249 17.5856L10.4113 17.5029L21.9113 6.50295L22.0057 6.41262L21.9113 6.32229L20.56 5.02979L20.4736 4.94718L20.3872 5.02975L10.3249 14.6455L6.41501 10.9056Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2226_11973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    fill: "white",
    transform: "translate(0 0.166016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.35ff5e3bef7f4d653c4f1875afdddb22.svg";
export { ForwardRef as ReactComponent };